export function mergeEmails(existing: string[], incoming: string[]): string[] {
  return Array.from(new Set([...existing, ...incoming])).slice(-3)
}

/**
 * According to google docs, we should remove the periods from gmail.com and googlemail.com email addresses.
 * https://support.google.com/google-ads/answer/13258081?#Add_a_code_snippet&zippy=identify-and-define-your-enhanced-conversions-fields
 */
export function normalizeGoogleEmailAddresses(email: string): string {
  const normalized = email.trim().toLowerCase()
  const [local, domain] = normalized.split('@')

  if (!domain || !local) return normalized // fallback safety

  if (domain === 'gmail.com' || domain === 'googlemail.com') {
    const cleanedLocal = local
      .replace(/\./g, '') // remove dots
      .replace(/\+.*$/, '') // remove +aliases
    return `${cleanedLocal}@gmail.com`
  }

  return `${local}@${domain}`
}

/**
 * According to Google’s Enhanced Conversions docs:
 * https://support.google.com/google-ads/answer/13258081#zippy=%2Cidentify-and-define-your-enhanced-conversions-fields
 *
 * - Remove periods from Gmail and Googlemail addresses.
 * - Remove +aliases.
 * - Convert all text fields to lowercase and trim spaces.
 */
export function normalizeUserData(userData: IGTagUserData): IGTagUserData {
  const normalized: IGTagUserData = { ...userData }

  // Normalize emails (lowercase, Gmail rules)
  if (userData.email?.length) {
    normalized.email = userData.email.map(e =>
      normalizeGoogleEmailAddresses(e.trim().toLowerCase())
    )
  }

  // Normalize address
  if (userData.address) {
    const address = userData.address
    const normalizedAddress: Partial<IGTagUserData['address']> = {}

    for (const [key, value] of Object.entries(address)) {
      (normalizedAddress as any)[key] =
        typeof value === 'string' ? value.trim().toLowerCase() : value
    }

    normalized.address = normalizedAddress
  }

  return normalized
}
